<template>
    <component
        :is="icon"
        :size="size"
        ></component>
</template>

<script>


import { components } from '../../icons/index';

export default {
    name: "Icon",
    components: components, 
    props: ["name", "solid", "size"],
    computed: {
        icon() {
            return "Icon" + this.name + (this.solid ? 'Solid' : 'Outline');
        }
    }
}
</script>

<style scoped>

</style>
